var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "btn-normal",
    attrs: {
      "href": "#",
      "data-type": _vm.color,
      "class-type": _vm.classType
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.clickButton.apply(null, arguments);
      }
    }
  }, [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }